// extracted by mini-css-extract-plugin
module.exports = {"container":"_2b285909","imageLinkWrapper":"_2f6cc01a","imageWrapper":"_ab80f93a","image":"_f9e6dc29","info":"_e54fb060","title":"_81d8db6e","price":"_d8d66a83"};